import React from "react";
import {ArrowBackCircle} from 'react-ionicons'
import 'bootstrap/dist/css/bootstrap.min.css';
import 'jquery/dist/jquery.min.js';
import 'bootstrap/dist/js/bootstrap.min.js';
import 'bootstrap/dist/css/bootstrap.min.css';
import "@popperjs/core"
import constantURI from "../URI"
import _post from "../Functions/NoBodyPost";
import WMSAuthenticate from "../Functions/WMSAuthenticate"
import stylesWMS from "./stylesWMS";
import stylesMed from "../MedRep/stylesMed";
import DatePicker from "react-datepicker";
import SearchFilterFunction from "../Functions/SearchFilter"

export default class Packages extends React.Component {

    constructor() {
        super();
        this.state = {
            orders: [],
            showDeleteAlert: false,
            requiredFields: {Date: true, location: false, source: false},
            showalert: false,
            alertdanger: "",
            itemIndex: 0,
            bar: "",
            Date: new Date(),
            authenticate: false,
            token: "",
            location: "",
            locations: [],
            task: [],
            loading: true,
            ordersCopy: [],
            noData: true,
            tableHeader: [],
            transactionType: [{"name": "/Requests"}, {"name": "/Transfers"}],
            selectedType: -1,
            source: "",
            destination: "",
            showBar: false,
            disableScan: true,
            module: 1,
            transaction: -1,
            status: [],
            stage: "",
            loadingData: false,
            username: ""
        }
    }

    async componentDidMount() {
        document.body.style.backgroundColor = "#e6e6fa";

        //checking if there is internet connectivity 
        await WMSAuthenticate().then((response) => {
            this.setState({authenticate: response});
        });

        const token = JSON.parse(localStorage.getItem("Token"));
        const user = JSON.parse(localStorage.getItem("Username"));
        this.setState({token: token, username: user});
        this.compWMS();
    }

    compWMS = async () => {
        this.setState({tableHeader: [{"name": "Name"}, {"name": "Date"}, {"name": "Source"}, {"name": "Destination"}]});

        const getLocations = constantURI() + "GetLocations?token=" + this.state.token+ "&user=" + this.state.username + "&type=internal";
        //If online
        if (this.state.authenticate) {
            await _post(getLocations).then((response) => {
                return response.json().then((data) => {
                    if (data.result !== undefined) {
                        this.setState({locations: data.result, loading: false});
                        localStorage.setItem('Locations', JSON.stringify(this.state.locations));
                    } else {
                        const location = localStorage.getItem('Locations');
                        this.setState({locations: JSON.parse(location), loading: false});
                    }
                })
            })
        }
        //If offline
        else {
            const location = localStorage.getItem('Locations');
            if (location === null || location === undefined) {
                alert("Please connect to the Internet");
                this.props.history.push("/LandingPageWMS");
            } else {
                this.setState({locations: JSON.parse(location), loading: false});
            }
        }
    }

    onChangeBar = (e) => {
        this.setState({bar: e.target.value.substring(0, 10)});
    }

    onOrderClick = async (item) => {
        //checking if there is internet connectivity 
        await WMSAuthenticate().then((response) => {
            this.setState({authenticate: response});
        });
        //If online
        if (this.state.authenticate) {
            localStorage.setItem("Transaction", JSON.stringify(item));
            this.props.history.push("/PackagesList");
        }
        //If offline
        else {
            alert("Please connect to the internet");
        }
    }

    onSearch = async (text) => {
        var values = await SearchFilterFunction(text, this.state.orders, this.state.ordersCopy, this.state.noData);
        this.setState({orders: values.items, noData: values.noData})
    }

    onSelectFromDate = async (date) => {
        await this.setState({Date: date});

        if (date === null || date === "")
            this.setState({...this.state.requiredFields.Date = false, showBar: false});
        else
            this.setState({...this.state.requiredFields.Date = true});

        if (this.state.requiredFields.Date && this.state.requiredFields.location) {
            this.setState({disableScan: false});
        } else {
            this.setState({disableScan: true});
        }

    }

    onChangeLocation = (e) => {
        this.setState({location: e.target.value, destination: e.target.options[e.target.selectedIndex].text});

        if (e.target.value === "")
            this.setState({...this.state.requiredFields.location = false, showBar: false});
        else
            this.setState({...this.state.requiredFields.location = true});
        //If WMS
        if (this.state.transaction === 0) {
            //If transaction is RFQ
            if (this.state.selectedType === 0) {
                if (this.state.requiredFields.Date && this.state.requiredFields.location) {
                    this.setState({disableScan: false});
                } else {
                    this.setState({disableScan: true});
                }
            }
            //If transaction is transfer
            else if (this.state.selectedType === 1) {
                if (this.state.requiredFields.source && this.state.requiredFields.location) {
                    this.setState({disableScan: false});
                } else {
                    this.setState({disableScan: true});
                }
            }
        }
    }

    getOrders = async (values) => {
        this.setState({loadingData: true});
        //If transaction is RFQ or if selected module is OMS
        if (!values.Date && !values.location) {
            this.setState({alertdanger: "Date & Destination are required"});
            this.setState({showalert: true, loadingData: false});
        } else if (!values.Date && values.location) {
            this.setState({alertdanger: "Date is required"});
            this.setState({showalert: true, loadingData: false});
        } else if (values.Date && !values.location) {
            this.setState({alertdanger: "Destination is required"});
            this.setState({showalert: true, loadingData: false});
        } else {
            this.isDone();
        }
    }

    isDone = async () => {
        //checking if there is internet connectivity 
        await WMSAuthenticate().then((response) => {
            this.setState({authenticate: response});
        });
        var readURI = constantURI();
        //If online
        if (this.state.authenticate) {
            const tempToDate = new Date(this.state.Date);
            const date = `${tempToDate.getFullYear()}/${tempToDate.getMonth() + 1}/${tempToDate.getDate()}`;
            this.setState({alertdanger: "Work Successful"});
            readURI = readURI + "GetPOs?token=" + this.state.token+ "&user=" + this.state.username + "&type=3&location=" + Number(this.state.location) + "&date=" + date;
            await _post(readURI).then((response) => {
                return response.json().then(async (data) => {
                    if (data.result !== undefined) {
                        await this.setState({orders: data.result, ordersCopy: data.result, loadingData: false});
                        localStorage.setItem('Transactions', JSON.stringify(this.state.orders));
                    } else {
                        const orders = localStorage.getItem('Transactions');
                        this.setState({orders: JSON.parse(orders), loadingData: false});
                    }
                })
            })
        }
        //If offline
        else {
            this.setState({alertdanger: "Please connect to the internet!"});
        }
    }

    Header = () => {
        return (
            <div>
                <div className="row pt-3">
                    <div className="col">
                        <ArrowBackCircle className="btn" onClick={() => this.props.history.push("/LandingPageWMS")}
                                         color={'#00bfff'} height="50px" width="50px"/>
                    </div>
                    <h3 className="col d-flex align-items-center justify-items-center">Packages</h3>
                    <div className="col m-4">
                        <button className="btn btn-sm" style={stylesWMS.transactionButton}
                                onClick={() => this.getOrders(this.state.requiredFields)}>Get RFQs
                        </button>
                    </div>
                </div>
                <br/>
            </div>
        )
    }

    subHeader = () => {
        return (
            <div>
                <div className="row">
                    <div className="col m-4">
                        <h6 style={stylesWMS.reportDate}>Date </h6>
                        <div style={stylesWMS.datelocation}><DatePicker className="form-control"
                                                                        selected={this.state.Date}
                                                                        onChange={(date) => this.onSelectFromDate(date)}
                                                                        style={stylesWMS.datelocation}/></div>
                    </div>
                    <div className="col m-4">
                        <h6 style={stylesWMS.reportDate}>Destination </h6>
                        <select className="form-control" id="sel1" value={this.state.location}
                                onChange={this.onChangeLocation}
                                name="sellist1" style={stylesWMS.datelocation}>
                            <option value=""></option>
                            {this.state.locations.map((item, index) => {
                                return (
                                    <option key={index}
                                            value={item.id}>{(item.complete_name !== undefined) ? item.complete_name : item.city}</option>
                                )
                            })
                            }
                        </select>
                    </div>
                </div>
                <div className="p-4">
                    <input type="text" className="form-control" placeholder="Search Here"
                           onInput={text => this.onSearch(text)}/>
                </div>
            </div>
        )
    }

    render() {
        if (!this.state.loading) {
            return (
                <div className="container-fluid vh-100" style={stylesWMS.mainContainer}>
                    {(this.state.showalert) ?
                        <div
                            className={(this.state.alertdanger === "Work Successful") ? "alert alert-success" : "alert alert-danger"}>{this.state.alertdanger}</div>
                        : null}
                    {this.Header()}
                    {this.subHeader()}
                    <div className="m-4 p-4" style={stylesMed.cardBackgroundColor}>
                        <div className="row">
                            {this.state.tableHeader.map((item, index) => {
                                return (
                                    <h4 className={(this.state.transaction === 0) ? "col-sm-3 text-center" : "col text-center"}
                                        key={index}> {item.name} </h4>
                                )
                            })
                            }
                        </div>
                        <hr/>
                        {(this.state.loadingData)
                            ? <div className="pt-3 text-center">
                                <div className="spinner-border" style={stylesMed.spinner}></div>
                            </div>
                            :
                            this.state.orders.map((item, index) => {
                                return (
                                    <div>
                                        <div className="row" key={index} onClick={() => this.onOrderClick(item)}>
                                            <h4 className="col-sm-3 text-center">{item.name}</h4>
                                            <h4 className="col-sm-3 text-center">{(item.date_order === undefined) ? item.scheduled_date.substring(0, 10) : item.date_order.substring(0, 10)}</h4>
                                            <h4 className="col-sm-3 text-center">{(item.location_id !== undefined) ? item.location_id[1] : item.source_location_id[1]}</h4>
                                            <h4 className="col-sm-3 text-center">{(item.location_dest_id !== undefined) ? item.location_dest_id[1] : item.dest_location_id[1]}</h4>
                                        </div>
                                        <hr/>
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
            );
        } else {
            return (
                <div className="container-fluid vh-100" style={stylesMed.mainContainer}>
                    {this.Header()}
                    <div className="pt-3 text-center">
                        <div className="spinner-border" style={stylesMed.spinner}></div>
                    </div>
                </div>
            )
        }

    }
}
